module.exports = __webpack_public_path__ + "media/images/fb-share-7d7a2e2534a3b256beb1e1562bfb1ee6.png";